/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const ProjectFolder56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M17 44c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zM45 5a6 6 0 110 12 6 6 0 010-12z"
            />
            <circle cx={45} cy={11} r={6} fill={vars.bdlBoxBlue10} />
            <circle cx={17} cy={48} r={4} fill={vars.bdlBoxBlue10} />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M14.93 9H8a1 1 0 00-.993.883L7 10v29a1.886 1.886 0 00.034.367c.015.084.036.167.062.247l.045.125.056.128.08.15.063.099.097.131.134.152.168.153.09.07.13.086.111.063.184.085.216.073.159.037.104.016.116.012L9 41a2.001 2.001 0 001.995-1.85L11 39V21c0-2.718 2.35-4.889 5.247-4.996L16.47 16H44v-1a3 3 0 00-2.824-2.995L41 12H19.07a3.003 3.003 0 01-2.38-1.173l-.116-.163-.812-1.219a1.004 1.004 0 00-.708-.437L14.93 9z"
            />
            <path fill={vars.white} d="M18 16h27a6 6 0 016 6v15a6 6 0 01-6 6H12V22a6 6 0 016-6z" />
            <path fill={vars.bdlBoxBlue10} fillRule="nonzero" d="M38 29a6 6 0 100 12 6 6 0 000-12z" />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M40.5 50a.5.5 0 01.09.992L40.5 51h-5a.5.5 0 01-.09-.992L35.5 50h5zM38 27a8 8 0 015.195 14.084l-.194.16L43 46a3 3 0 01-2.824 2.995L40 49h-4a3 3 0 01-2.995-2.824L33 46l-.001-4.756.052.042A8 8 0 0138 27zm3.001 15.418l.016-.006A7.985 7.985 0 0138 43c-1 0-1.958-.184-2.84-.519l-.16-.063V46c0 .473.329.87.77.974l.113.02L36 47h4a1 1 0 00.993-.883L41 46l.001-3.582zM14.93 7c.936 0 1.814.437 2.38 1.173l.116.163.812 1.219c.163.243.422.401.708.437l.124.008H41a4.999 4.999 0 014.995 4.783L46 16h-.47c2.923 0 5.346 2.103 5.465 4.792L51 21v17.764c0 1.75-.988 3.348-2.553 4.13a1 1 0 11-.894-1.788 2.618 2.618 0 001.44-2.157l.007-.185V21c0-1.574-1.427-2.905-3.271-2.995l-.2-.005H16.471c-1.874 0-3.365 1.277-3.466 2.832L13 21v18c0 .729-.195 1.413-.536 2.001L27 41a1 1 0 01.117 1.993L27 43H9a4 4 0 01-3.995-3.8L5 39V10a3 3 0 012.824-2.995L8 7h6.93zm0 2H8a1 1 0 00-.993.883L7 10v29a1.886 1.886 0 00.034.367c.015.084.036.167.062.247l.045.125.056.128.08.15.063.099.097.131.134.152.168.153.09.07.13.086.111.063.184.085.216.073.159.037.104.016.116.012L9 41a2.001 2.001 0 001.995-1.85L11 39V21c0-2.718 2.35-4.889 5.247-4.996L16.47 16H44v-1a3 3 0 00-2.824-2.995L41 12H19.07a3.003 3.003 0 01-2.38-1.173l-.116-.163-.812-1.219a1.004 1.004 0 00-.708-.437L14.93 9zM38 29a6 6 0 00-.5 11.98V35.5a.5.5 0 01.992-.09l.008.09v5.48A6 6 0 0038 29zm.5-6a.5.5 0 010 1h-15a.5.5 0 010-1h15zm-25-13a.5.5 0 010 1h-4a.5.5 0 010-1h4z"
            />
        </g>
    </AccessibleSVG>
);

export default ProjectFolder56;
